module.exports = __webpack_public_path__ + "static/media/Logo.8fe927be.png";